export interface PlatformNavItem {
  name: string;
  path: string;
  description?: string;
}

export const PLATFORM_NAV: PlatformNavItem[] = [
  { name: 'Dashboard', path: '/platform', description: 'Platform overview' },
  { name: 'Tenants', path: '/platform/tenants', description: 'Manage organizations' },
  { name: 'Analytics', path: '/platform/analytics', description: 'Cross-tenant metrics' },
  { name: 'Audit Log', path: '/platform/audit', description: 'Platform activity' },
  { name: 'Settings', path: '/platform/settings', description: 'Platform configuration' },
];
